"use client";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";
import Image from "next/image";
import { useState, useMemo } from "react";
import { ImageViewer } from "./ImageViewer";

const imageTypes = [
  { type: "primary", label: "Primary" },
  { type: "secondary", label: "Secondary" },
  { type: "tertiary", label: "Tertiary" },
];

export function OpenBoxImages({ openBoxImages }) {
  const [imageStates, setImageStates] = useState({
    primary: true,
    secondary: true,
    tertiary: true,
  });
  const [selectedImage, setSelectedImage] = useState(null);

  const validImages = useMemo(
    () =>
      imageTypes
        .map(({ type, label }) => {
          const imageUrl = openBoxImages[type];
          return imageUrl && imageUrl.trim() !== "" && imageUrl !== "- None -"
            ? { type, label, imageUrl }
            : null;
        })
        .filter(Boolean),
    [openBoxImages]
  );

  const handleImageLoad = (type) => {
    setImageStates((prev) => ({
      ...prev,
      [type]: false,
    }));
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleCloseViewer = () => {
    setSelectedImage(null);
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-blue5 text-[13px] leading-[20px] bg-transparent border-0 hover:underline">
          Open-Box Images
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-[750px] md:max-w-[90vw] rounded-[20px] p-0">
        <DialogHeader>
          <DialogTitle className="border-b border-gray21 text-[25px] py-[30px] px-4 leading-[37px] font-semibold text-blue2 ">
            Open-Box Images
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="px-9 py-[20px] overflow-y-auto">
          <div className="w-full flex gap-6 md:justify-start justify-center overflow-x-auto snap-x snap-mandatory scrollbar-hidden touch-pan-x overflow-y-hidden">
            {validImages.length > 0 ? (
              validImages.map(({ type, label, imageUrl }) => (
                <div
                  key={type}
                  className="flex flex-col items-center  min-w-[200px] max-w-[200px] snap-center"
                >
                  {/* <p className="text-center mb-2 font-semibold text-gray-800">{label}</p> */}
                  <div
                    className="relative w-[200px] rounded-[6px] cursor-pointer"
                    onClick={() => handleImageClick(imageUrl)}
                  >
                    {imageStates[type] && (
                      <Skeleton className="w-[200px] h-[300px] bg-gray-200" />
                    )}
                    <Image
                      src={imageUrl}
                      alt={`${label} Image`}
                      width={200}
                      height={250}
                      className={`object-cover border border-gray-200 px-2 py-1 rounded-[6px] ${
                        imageStates[type] ? "hidden" : "block"
                      }`}
                      onLoad={() => handleImageLoad(type)}
                      quality={75}
                      loading="eager"
                      sizes="(max-width: 400px) 100vw, 50vw"
                    />
                  </div>
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center w-[250px] h-[100px] justify-center">
                <h3 className="text-[20px] font-semibold mb-4 text-gray-800">
                  No Image Available
                </h3>
                <span className="text-[16px] text-gray-600">
                  Contact Us for More Details
                </span>
              </div>
            )}
          </div>
        </DialogDescription>
      </DialogContent>
      {selectedImage && (
  <ImageViewer
    imageUrl={selectedImage}
    images={[
      selectedImage,
      ...validImages
        .map((img) => img.imageUrl)
        .filter((img) => img !== selectedImage),
    ]}
    onClose={handleCloseViewer}
  />
)}

    </Dialog>
  );
}